import React, { Component, Fragment } from "react";
import Navbar from "../../Components/ProducaoSTI/Realizado/UI/Navbar";
import Agregador from "../../Components/ProducaoSTI/Realizado/Relatorio2/Agregador";
import Switcher from "../../Components/ProducaoSTI/Realizado/Relatorio2/Switcher";
import Select from "../../Components/ProducaoSTI/Realizado/Relatorio1/Select";
import NomeUnidade from "../../Components/UI/NomeUnidade";
import MenuRelatorioSTI from "./menuRelatorioSTI";

export default class PageRelatorio2 extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Relatório",
            colunas: this.colunasDisponiveis(),
            colunasSelecionadas: []
        }
    }

    componentDidMount() {
        this.setState({ colunasSelecionadas: this.colunasUseMemo() })
    }

    onChange = (event) => {
        let novasColunas = { ...this.state.colunas };
        novasColunas[event.target.id] = !novasColunas[event.target.id];
        let colunasSelecionadas = this.colunasUseMemo(novasColunas);
        this.setState({ colunas: novasColunas, colunasSelecionadas });
    }

    colunasDisponiveis = () => {
        let colunas = {
            CODIGO_ATENDIMENTO_INTEGRADOR: false,
            CODIGO_UNIDADE_DR: false,
            UNIDADE: true,
            CODIGO_ATENDIMENTO_DR: false,
            SITUACAO_ATENDIMENTO: true,
            DESCRICAO_ATENDIMENTO: false,
            DESCRICAO_SERVICO: true,
            CATEGORIA_SERVICO: true,
            DESCRICAO_PRODUTO_NACIONAL: false,
            ORIGEM_RECURSO: false,
            ATENDIMENTO_EM_REDE: false,
            DRS_ATENDIMENTO_REDE: false,
            MUNICIPIO_ATENDIMENTO: false,
            DATA_INICIO_ATENDIMENTO: false,
            DATA_FIM_PREVISTO_ATENDIMENTO: false,
            DATA_FIM_ATENDIMENTO: false,
            FF_VALOR_SERVICO_PRESTADO: false,
            FF_VL_FINANCEIRO: false,
            FF_VL_ECONOMICO: false,
            FN_QT_HORAS_PREVISTAS: false,
            FN_QT_ENSAIOS_PREVISTOS: false,
            FN_QT_CALIBRAÇÕES_PREVISTAS: false,
            FN_QT_MAT_REF_PREVISTOS: false,
            FN_QT_RELATÓRIOS_PREVISTOS: false,
            FN_QT_HORAS_REALIZADAS: true,
            FN_QT_ENSAIOS_REALIZADOS: false,
            FN_QT_CALIBRAÇÕES_REALIZADAS: false,
            FN_QT_MAT_REF_REALIZADOS: false,
            FN_QT_RELATÓRIOS_REALIZADOS: true,
            FF_VL_PRODUCAO: false,
            TIPO_PESSOA_FISICA: false,
            CPF: false,
            PASSAPORTE: false,
            NOME: false,
            UF: false,
            MUNICIPIO: false,
            CEP: false,
            TIPO_PESSOA_JURIDICA: false,
            CNPJ: false,
            NR_DOCUMENTO_ESTRANGEIRO: false,
            RAZAO_SOCIAL: false,
            NOME_FANTASIA: false,
            PAIS_PJ_ESTRANGEIRA: false,
        }
        return colunas;
    }

    colunasUseMemo = (colunas) => {

        if(!colunas) {
            colunas = this.state.colunas
        }
        
        let columns = []
        let tipoAgregadoSoma = [
            'FF_VALOR_SERVICO_PRESTADO',
            'FF_VL_FINANCEIRO',
            'FF_VL_ECONOMICO',
            'FN_QT_HORAS_PREVISTAS',
            'FN_QT_ENSAIOS_PREVISTOS',
            'FN_QT_CALIBRAÇÕES_PREVISTAS',
            'FN_QT_MAT_REF_PREVISTOS',
            'FN_QT_RELATÓRIOS_PREVISTOS',
            'FN_QT_HORAS_REALIZADA',
            'FN_QT_ENSAIOS_REALIZADO',
            'FN_QT_CALIBRAÇÕES_REALIZADA',
            'FN_QT_MAT_REF_REALIZADO',
            'FN_QT_RELATÓRIOS_REALIZADO',
            'FF_VL_PRODUCAO',
        ];

        Object.keys(colunas).map((col, i) => {
            if(colunas[col]) {
                columns.push({
                    Header: col.replaceAll("_", " "),
                    accessor: col,
                    //aggregate: tipoAgregadoSoma.includes(col) ? 'sum' : 'count',
                    aggregate: tipoAgregadoSoma.includes(col) ? this.somaTotalHora : 'count',
                    Aggregated: ({ value }) => `${value}`,
                    
                })
            }
        })

        //this.setState({ colunasSelecionadas: columns });
        return columns

    }

    somaTotalHora = (leafValues, aggregatedValues) => {
        let somaTotal = aggregatedValues.reduce((acc, atual) => acc + Number(atual), 0);
        return somaTotal;
    }

    render() {
        let { colunas, colunasSelecionadas, url } = this.state;
        return(
            <Fragment>

                <NomeUnidade unidade={"Relatórios"} />

                <div className="content">
                    <MenuRelatorioSTI />
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-header">
                                    Opções
                                </div>
                                <div className="card-body">
                                    <Switcher onChange={this.onChange} colunas={colunas} />
                                </div>
                            </div>

                            <Agregador colunas={colunas} colunasSelecionadas={colunasSelecionadas} url={url} />
                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }
}